module.exports = __webpack_public_path__ + "img/zs_icon_gk.a6592a0e.svg";